import builder from '../builder';
import AlertDangerLight from '../../streamline-icons/light/alert-danger-light.svg';

export default builder('IconCheckCircle1Bold', AlertDangerLight);
